module.exports = __webpack_public_path__ + "static/img/right-num-row-7.8ea530fa.webp";